<template>
  <div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
    >
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :maskClosable="false"
      :title="null"
      :closable="false"
      :width="720"
      :footer="false"
      :bodyStyle="{ padding: 0 }"
      wrapClassName="feed-form-modal"
      destroyOnClose
      centered
    >
      <div class="news-form-header">
        <span class="news-form-title">
          <span class="news-form-title-icon" :class="isAlbum ? 'icon-album' : 'icon-news'">
            <a-icon :type="isAlbum ? 'camera' : 'file-text'" />
          </span>
          {{ getModalTitle }}
        </span>
        <button
          type="button"
          class="news-form-close"
          :disabled="loading"
          @click="handleCancel"
          aria-label="close"
        >
          <a-icon type="close" />
        </button>
      </div>
      <a-form
        :form="form"
        layout="vertical"
        @submit="handleSubmit"
      >
      <div class="news-form-body">
        <a-form-item :label="$t('actualite.titre')">
          <a-input
            :placeholder="$t('actualite.titre')"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.titre'),
                  },
                  {
                    whitespace: true,
                    message: $t('requis.titre'),
                  },
                  {
                    transform: (value) => (value ? value.trim() : value),
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item :label="$t('actualite.date')" v-if="!isEdit">
          <a-date-picker
            class="full"
            :placeholder="$t('actualite.date')"
            show-time
            format="DD/MM/YYYY HH:mm:ss"
            v-decorator="[
              'plannifDate',
              {
                initialValue: moment(), // Set initial value to current date using moment.js
                rules: [
                  {
                    required: true,
                    message: $t('requis.date'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item v-if="!isAlbum" :label="$t('actualite.categorie')">
          <a-select
            :placeholder="$t('actualite.categorie')"
            allowClear
            @change="handleCategoryChange"
            v-decorator="[
              'category',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.categorie'),
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="option in categoryOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="!isAlbum && form.getFieldValue('category') === OTHER_CATEGORY_VALUE"
          :label="$t('actualite.customCategory')"
        >
          <a-input
            type="string"
            :placeholder="$t('actualite.customCategoryPlaceholder')"
            v-decorator="[
              'customCategory',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.categorie'),
                  },
                  {
                    whitespace: true,
                    message: $t('requis.categorie'),
                  },
                  {
                    transform: (value) => (value ? value.trim() : value),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$t('actualite.cibles')">
          <a-select
            mode="multiple"
            :placeholder="$t('actualite.cibles')"
            @change="
              (val) => {
                if (!val.includes('parents') && !val.includes('students')) selectedStudents = [];
                if (!val.includes('teacher')) selectedTeachers = [];
              }
            "
            v-decorator="[
              'target',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.cible'),
                  },
                ],
              },
            ]"
          >
            <a-select-option value="all">
              {{ $t("actualite.tous") }}
            </a-select-option>
            <a-select-option value="teacher">
              {{ $t("actualite.enseignants") }}
            </a-select-option>
            <a-select-option value="students">
              {{ $t("actualite.eleves") }}
            </a-select-option>
            <a-select-option value="administration">
              {{ $t("actualite.administration") }}
            </a-select-option>
            <a-select-option value="parents">
              {{ $t("actualite.parents") }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div
          v-if="
            form.getFieldValue('target') &&
            form.getFieldValue('target').includes('parents')
          "
          class="form-advanced-block"
        >
          <a-tag color="blue" class="filter-hint-tag">{{
            $t("actualite.specifiedInfo")
          }}</a-tag>
          <a-form-item :label="$t('actualite.specificFor')">
            <a-select
              @change="
                () => {
                  selectedStudents = [];
                }
              "
              v-decorator="[
                'specificFor',
                {
                  initialValue: 'all',
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                value="all"
                @change="
                  () => {
                    selectedStudents = [];
                  }
                "
              >
                {{ $t("actualite.tous") }}
              </a-select-option>
              <a-select-option value="students">
                {{ $t("actualite.students") }}
              </a-select-option>
              <a-select-option value="levels">
                {{ $t("actualite.levels") }}
              </a-select-option>
              <a-select-option value="classrooms">
                {{ $t("actualite.classrooms") }}
              </a-select-option>
              <a-select-option value="activities">
                {{ $t("actualite.activities") }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificFor') &&
              form.getFieldValue('specificFor') == 'levels'
            "
            :label="$t('actualite.levels')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'levels',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('enseignant.niveauxRequis'),
                    },
                  ],
                },
              ]"
              type="levels"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificFor') &&
              form.getFieldValue('specificFor') == 'classrooms'
            "
            :label="$t('actualite.classrooms')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'classrooms',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('choisir.classe'),
                    },
                  ],
                },
              ]"
              type="classrooms"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificFor') &&
              form.getFieldValue('specificFor') == 'students'
            "
            :label="$t('actualite.students')"
          >
            <multiselect
              v-model="selectedStudents"
              :placeholder="$t('sms.selectionnerEleves')"
              :selectLabel="$t('sms.pressEnterToSelect')"
              :options="studentList"
              :custom-label="customLabel"
              :close-on-select="false"
              :preserve-search="true"
              :maxHeight="700"
              label="_id"
              track-by="_id"
              :preselect-first="false"
              :multiple="true"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="align-text-top">
                    {{ studentOptionTitle(props.option) }}
                  </span>
                  <br /><span class="option__small font-size-12 text-warning"
                    >Parent: {{ parentOptionLine(props.option.parent && props.option.parent.father) }}
                    {{ $t("all.and") }}
                    {{ parentOptionLine(props.option.parent && props.option.parent.mother) }}</span
                  >
                </div>
              </template>
            </multiselect>
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificFor') &&
              form.getFieldValue('specificFor') == 'activities'
            "
            :label="$t('actualite.activities')"
          >
            <a-select
              :placeholder="$t('actualite.selectActivities')"
              mode="multiple"
              v-decorator="[
                'activities',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('actualite.activitiesRequired'),
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="activity in activitiesList"
                :key="activity._id"
                :value="activity._id"
              >
                {{ activity.designation }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <!-- Student-specific targeting section -->
        <div
          v-if="
            form.getFieldValue('target') &&
            form.getFieldValue('target').includes('students')
          "
          class="form-advanced-block"
        >
          <a-tag color="orange" class="filter-hint-tag">{{
            $t("actualite.studentSpecifiedInfo")
          }}</a-tag>
          <a-form-item :label="$t('actualite.specificFor')">
            <a-select
              @change="
                () => {
                  selectedTargetStudents = [];
                }
              "
              v-decorator="[
                'specificForStudents',
                {
                  initialValue: 'all',
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option value="all">
                {{ $t("actualite.tous") }}
              </a-select-option>
              <a-select-option value="students">
                {{ $t("actualite.students") }}
              </a-select-option>
              <a-select-option value="levels">
                {{ $t("actualite.levels") }}
              </a-select-option>
              <a-select-option value="classrooms">
                {{ $t("actualite.classrooms") }}
              </a-select-option>
              <a-select-option value="activities">
                {{ $t("actualite.activities") }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForStudents') &&
              form.getFieldValue('specificForStudents') == 'levels'
            "
            :label="$t('actualite.levels')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'levelsStudents',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('enseignant.niveauxRequis'),
                    },
                  ],
                },
              ]"
              type="levels"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForStudents') &&
              form.getFieldValue('specificForStudents') == 'classrooms'
            "
            :label="$t('actualite.classrooms')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'classroomsStudents',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('choisir.classe'),
                    },
                  ],
                },
              ]"
              type="classrooms"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForStudents') &&
              form.getFieldValue('specificForStudents') == 'students'
            "
            :label="$t('actualite.students')"
          >
            <multiselect
              v-model="selectedTargetStudents"
              :placeholder="$t('sms.selectionnerEleves')"
              :selectLabel="$t('sms.pressEnterToSelect')"
              :options="studentList"
              :custom-label="customLabel"
              :close-on-select="false"
              :preserve-search="true"
              :maxHeight="700"
              label="_id"
              track-by="_id"
              :preselect-first="false"
              :multiple="true"
            >
            </multiselect>
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForStudents') &&
              form.getFieldValue('specificForStudents') == 'activities'
            "
            :label="$t('actualite.activities')"
          >
            <a-select
              :placeholder="$t('actualite.selectActivities')"
              mode="multiple"
              v-decorator="[
                'activitiesStudents',
                {
                  rules: [
                    {
                      required: true,
                      message: $t('actualite.activitiesRequired'),
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="activity in activitiesList"
                :key="activity._id"
                :value="activity._id"
              >
                {{ activity.designation }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <!-- Teacher-specific targeting section -->
        <div
          v-if="
            form.getFieldValue('target') &&
            form.getFieldValue('target').includes('teacher')
          "
          class="form-advanced-block"
        >
          <a-tag color="green" class="filter-hint-tag">{{
            $t("actualite.teacherSpecifiedInfo")
          }}</a-tag>
          <a-form-item :label="$t('actualite.specificFor')">
            <a-select
              @change="
                () => {
                  selectedTeachers = [];
                }
              "
              v-decorator="[
                'specificForTeachers',
                {
                  initialValue: 'all',
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option value="all">
                {{ $t("actualite.tous") }}
              </a-select-option>
              <a-select-option value="teachers">
                {{ $t("actualite.teachers") }}
              </a-select-option>
              <a-select-option value="levels">
                {{ $t("actualite.levels") }}
              </a-select-option>
              <a-select-option value="classrooms">
                {{ $t("actualite.classrooms") }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForTeachers') &&
              form.getFieldValue('specificForTeachers') == 'levels'
            "
            :label="$t('actualite.levels')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'levelsTeachers',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('enseignant.niveauxRequis'),
                    },
                  ],
                },
              ]"
              type="levels"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForTeachers') &&
              form.getFieldValue('specificForTeachers') == 'classrooms'
            "
            :label="$t('actualite.classrooms')"
          >
            <LevelsClassroomsFilter
              v-decorator="[
                'classroomsTeachers',
                {
                  initialValue: [],
                  rules: [
                    {
                      required: true,
                      message: $t('choisir.classe'),
                    },
                  ],
                },
              ]"
              type="classrooms"
              :level-options="levelOptions"
              :classes="classes"
            />
          </a-form-item>

          <a-form-item
            v-if="
              form.getFieldValue('specificForTeachers') &&
              form.getFieldValue('specificForTeachers') == 'teachers'
            "
            :label="$t('actualite.teachers')"
          >
            <multiselect
              v-model="selectedTeachers"
              :placeholder="$t('actualite.selectionnerEnseignants')"
              :selectLabel="$t('sms.pressEnterToSelect')"
              :options="teacherList"
              :custom-label="customTeacherLabel"
              :close-on-select="false"
              :preserve-search="true"
              :maxHeight="700"
              label="_id"
              track-by="_id"
              :preselect-first="false"
              :multiple="true"
            >
            </multiselect>
          </a-form-item>
        </div>

        <a-form-item v-if="!isAlbum" :label="$t('actualite.description')">
          <quill-editor v-model="description" :options="editorOptions" />
        </a-form-item>

        <a-form-item
          :label="isAlbum ? $t('actualite.photos') : $t('actualite.files')"
        >
          <a-upload-dragger
            v-if="!isAlbum"
            :file-list="photos"
            :before-upload="beforeUploadFiles"
            @change="handleChangeUpload"
            multiple
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            :custom-request="
              () => {
                return true;
              }
            "
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">{{ $t("actualite.cliquer") }}</p>
            <p class="ant-upload-hint">
              {{ $t("actualite.support") }}
            </p>
          </a-upload-dragger>
          <div class="clearfix" v-else>
            <a-upload
              list-type="picture-card"
              :file-list="photos"
              :before-upload="beforeUploadFilesAlbum"
              multiple
              accept=".jpg,.jpeg,.png,image/jpeg,image/png"
              :custom-request="
                () => {
                  return true;
                }
              "
              @preview="handlePreview"
              @change="handleChange"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">{{ $t("action.upload") }}</div>
              </div>
            </a-upload>
          </div>
        </a-form-item>

        <!-- Video Upload Section -->
        <a-form-item v-if="!isAlbum" :label="$t('actualite.videos')">
          <a-upload-dragger
            :file-list="videos"
            :before-upload="beforeUploadVideos"
            @change="handleChangeVideoUpload"
            multiple
            accept="video/*"
            :custom-request="
              () => {
                return true;
              }
            "
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="video-camera" />
            </p>
            <p class="ant-upload-text">{{ $t("actualite.uploadVideo") }}</p>
            <p class="ant-upload-hint">
              {{ $t("actualite.videoSupport") }}
            </p>
          </a-upload-dragger>
        </a-form-item>

        <a-progress
          :stroke-color="{
            from: '#108ee9',
            to: '#87d068',
          }"
          v-if="progress.value > 0"
          :percent="progress.value"
          status="active"
        />

        </div>
        <div v-if="enableNewsComments" class="comments-toggle-section">
          <div class="comments-toggle-row">
            <span class="toggle-icon"><a-icon type="message" /></span>
            <div class="toggle-copy">
              <span class="toggle-label">{{ $t('actualite.enableCommentsForThisNews') }}</span>
              <div class="toggle-hint">
                {{ $t('actualite.enableCommentsForThisNewsDesc') }}
              </div>
            </div>
            <a-switch v-model="enableComments" />
          </div>
        </div>
        <div class="form-actions">
          <button
            type="button"
            class="form-btn ghost"
            :disabled="loading"
            @click="handleCancel"
          >
            {{ $t("action.annuler") }}
          </button>
          <button
            type="submit"
            class="form-btn primary"
            :disabled="loading"
          >
            <a-icon v-if="loading" type="loading" />
            {{ isEdit ? $t("action.modifier") : $t("action.ajouter") }}
          </button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */

import apiClient from "@/services/axios";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import MagicUrl from "quill-magic-url";
import "quill/dist/quill.snow.css";
import moment from "moment";
import { mapState } from "vuex";
import { getAllLevels } from "@/config/LevelConstants";
import { uploadFilesToS3 } from "@/services/uploadService";
import LevelsClassroomsFilter from "./LevelsClassroomsFilter.vue";

Quill.register("modules/magicUrl", MagicUrl);

export default {
  name: "actuality-form",
  components: {
    quillEditor,
    LevelsClassroomsFilter,
  },
  props: {
    enableNewsComments: {
      type: Boolean,
      default: true,
    },
    studentList: {
      type: Array,
      default: () => [],
    },
    classes: {
      type: Array,
      default: () => [],
    },
    teacherList: {
      type: Array,
      default: () => [],
    },
    activitiesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      previewVisible: false,
      previewImage: "",
      progress: { value: 0 },
      visibleModal: false,
      form: null,
      loading: false,
      photos: [],
      videos: [],
      description: "",
      enableComments: true,
      selectedStudents: [],
      selectedTargetStudents: [],
      selectedTeachers: [],
      isEdit: false,
      currentItem: null,
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["link"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],

            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
          magicUrl: true,
        },
      },
      isAlbum: false,
      CATEGORY_VALUES: {
        info: "info",
        importantInfo: "important_info",
        urgent: "urgent",
        avisImportant: "avis_important",
        avis: "avis",
        important: "important",
      },
      OTHER_CATEGORY_VALUE: "__other__",
    };
  },
  created() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user?.building?.find(
        (el) => el.dbName === this.settings?.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode || "TN";
    },
    allLevels() {
      return getAllLevels(this.$t.bind(this), this.countryCode);
    },
    levelOptions() {
      return Object.entries(this.allLevels || {}).map(([value, label]) => ({
        value,
        label,
      }));
    },
    getModalTitle() {
      if (this.isEdit) {
        return this.isAlbum
          ? this.$t("actualite.modifierAlbum")
          : this.$t("actualite.modifierActualite");
      }
      return this.isAlbum
        ? this.$t("actualite.ajouterAlbum")
        : this.$t("actualite.ajouterActualite");
    },
    categoryOptions() {
      return [
        { value: this.CATEGORY_VALUES.info, label: this.$t("actualite.categoryInfo") },
        { value: this.CATEGORY_VALUES.importantInfo, label: this.$t("actualite.categoryImportantInfo") },
        { value: this.CATEGORY_VALUES.urgent, label: this.$t("actualite.categoryUrgent") },
        { value: this.CATEGORY_VALUES.avisImportant, label: this.$t("actualite.categoryAvisImportant") },
        { value: this.CATEGORY_VALUES.avis, label: this.$t("actualite.categoryAvis") },
        { value: this.CATEGORY_VALUES.important, label: this.$t("actualite.categoryImportant") },
        { value: this.OTHER_CATEGORY_VALUE, label: this.$t("actualite.categoryOther") },
      ];
    },
  },
  methods: {
    handleCategoryChange(value) {
      if (value !== this.OTHER_CATEGORY_VALUE) {
        this.form.setFieldsValue({ customCategory: undefined });
      }
    },
    resolveCategoryFields(category) {
      const legacyCategoryMap = {
        "إعلام": this.CATEGORY_VALUES.info,
        "إعلام هام": this.CATEGORY_VALUES.importantInfo,
        "عاجل": this.CATEGORY_VALUES.urgent,
        "Avis important": this.CATEGORY_VALUES.avisImportant,
        Avis: this.CATEGORY_VALUES.avis,
        Important: this.CATEGORY_VALUES.important,
        Information: this.CATEGORY_VALUES.info,
        "Important information": this.CATEGORY_VALUES.importantInfo,
        Urgent: this.CATEGORY_VALUES.urgent,
        "Important notice": this.CATEGORY_VALUES.avisImportant,
        Notice: this.CATEGORY_VALUES.avis,
      };
      const normalizedCategory = legacyCategoryMap[category] || category;
      const presetValues = this.categoryOptions
        .filter((option) => option.value !== this.OTHER_CATEGORY_VALUE)
        .map((option) => option.value);
      if (presetValues.includes(normalizedCategory)) {
        return {
          categoryValue: normalizedCategory,
          customCategoryValue: undefined,
        };
      }
      return {
        categoryValue: this.OTHER_CATEGORY_VALUE,
        customCategoryValue: category || undefined,
      };
    },
    getCategoryFromValues(values) {
      if (values.category === this.OTHER_CATEGORY_VALUE) {
        return (values.customCategory || "").trim();
      }
      return values.category;
    },
    customLabel({ firstName, lastName }) {
      return `${lastName} ${firstName}`;
    },
    customTeacherLabel({ employee }) {
      if (!employee) return "";
      const { firstName, lastName, middleName } = employee;
      const m = middleName && String(middleName).trim();
      return m ? `${firstName} ${m} ${lastName}` : `${firstName} ${lastName}`;
    },
    studentOptionTitle(s) {
      if (!s) return "";
      const m = s.middleName && String(s.middleName).trim();
      return m ? `${s.firstName} ${m} ${s.lastName}` : `${s.firstName} ${s.lastName}`;
    },
    parentOptionLine(p) {
      if (!p) return "";
      const m = p.middleName && String(p.middleName).trim();
      return m ? `${p.firstName} ${m} ${p.lastName}` : `${p.firstName} ${p.lastName}`;
    },
    async showActualityModal(type, item = null) {
      this.isAlbum = type === 2;
      this.isEdit = !!item;
      this.currentItem = item;

      if (this.isEdit && item) {
        this.description = item.desc;
        this.enableComments = item.enableComments !== false;

        if (item.photos && item.photos.length > 0) {
          this.photos = item.photos.map((photo, index) => {
            const fullName = photo.split("/").pop();

            // Find the position of the timestamp separator
            const separatorIndex = fullName.indexOf("--");
            const nameAfterTimestamp =
              separatorIndex !== -1
                ? fullName.substring(separatorIndex + 2)
                : fullName;

            return {
              uid: index,
              name: nameAfterTimestamp,
              status: "done",
              url: this.$store.state.settings.resourcesUrl.replace(
                "FILE_PATH",
                photo
              ),
              thumbUrl: this.$store.state.settings.resourcesUrl.replace(
                "FILE_PATH",
                photo
              ),
              size: 0,
              isExisting: true, // Flag to identify existing photos
              response: photo, // Keep the original path
            };
          });
        }

        // Load existing videos
        if (item.videos && item.videos.length > 0) {
          this.videos = item.videos.map((video, index) => {
            // Use thumbnail if available, otherwise show a video icon
            const thumbnailUrl = video.thumbnailKey
              ? this.$store.state.settings.resourcesUrl.replace(
                  "FILE_PATH",
                  video.thumbnailKey
                )
              : null;

            const videoName = video.originalKey
              ? video.originalKey.split("/").pop()
              : `video-${index + 1}`;

            return {
              uid: `video-${index}`,
              name: videoName,
              status: "done",
              url: thumbnailUrl,
              thumbUrl: thumbnailUrl,
              size: 0,
              isExisting: true, // Flag to identify existing videos
              response: video, // Keep the full video object
              originalKey: video.originalKey,
            };
          });
        }

        if (item.students && item.students.length > 0) {
          this.selectedStudents = this.studentList.filter((student) =>
            item.students.includes(student._id)
          );
        }

        if (item.teachers && item.teachers.length > 0) {
          this.$nextTick(() => {
            this.selectedTeachers = this.teacherList.filter((teacher) =>
              item.teachers.includes(teacher._id)
            );
          });
        }

        if (item.targetStudents && item.targetStudents.length > 0) {
          this.$nextTick(() => {
            this.selectedTargetStudents = this.studentList.filter((student) =>
              item.targetStudents.includes(student._id)
            );
          });
        }

        // Create form with initial values
        this.form = this.$form.createForm(this, {
          mapPropsToFields: () => {
            const categoryFields = this.resolveCategoryFields(item.category);
            const fields = {
              title: this.$form.createFormField({ value: item.title }),
              category: this.$form.createFormField({ value: categoryFields.categoryValue }),
              customCategory: this.$form.createFormField({
                value: categoryFields.customCategoryValue,
              }),
              target: this.$form.createFormField({ value: item.target }),
            };

            // Handle parents targeting
            if (item.target?.includes("parents")) {
              fields.specificFor = this.$form.createFormField({
                value:
                  item.classrooms?.length > 0
                    ? "classrooms"
                    : item.levels?.length > 0
                    ? "levels"
                    : item.students?.length > 0
                    ? "students"
                    : item.activities?.length > 0
                    ? "activities"
                    : "all",
              });
              fields.levels = this.$form.createFormField({
                value: item.levels ? item.levels : [],
              });
              fields.classrooms = this.$form.createFormField({
                value: item.classrooms ? item.classrooms : [],
              });
              fields.activities = this.$form.createFormField({
                value: item.activities ? item.activities : [],
              });
            }

            // Handle students targeting - all, students, levels, classrooms, activities
            if (item.target?.includes("students")) {
              fields.specificForStudents = this.$form.createFormField({
                value:
                  item.targetStudents?.length > 0
                    ? "students"
                    : item.levelsStudents?.length > 0
                    ? "levels"
                    : item.classroomsStudents?.length > 0
                    ? "classrooms"
                    : item.activities?.length > 0
                    ? "activities"
                    : "all",
              });
              fields.levelsStudents = this.$form.createFormField({
                value: item.levelsStudents ? item.levelsStudents : [],
              });
              fields.classroomsStudents = this.$form.createFormField({
                value: item.classroomsStudents ? item.classroomsStudents : [],
              });
              fields.activitiesStudents = this.$form.createFormField({
                value: item.activities ? item.activities : [],
              });
            }

            // Handle teachers targeting - all, teachers, levels, classrooms
            if (item.target?.includes("teacher")) {
              fields.specificForTeachers = this.$form.createFormField({
                value:
                  item.levelsTeachers?.length > 0
                    ? "levels"
                    : item.classroomsTeachers?.length > 0
                    ? "classrooms"
                    : item.teachers?.length > 0
                    ? "teachers"
                    : "all",
              });
              fields.levelsTeachers = this.$form.createFormField({
                value: item.levelsTeachers ? item.levelsTeachers : [],
              });
              fields.classroomsTeachers = this.$form.createFormField({
                value: item.classroomsTeachers ? item.classroomsTeachers : [],
              });
            }

            return fields;
          },
        });
      } else {
        // For new items, create empty form
        this.form = this.$form.createForm(this);
        this.enableComments = this.enableNewsComments;
      }

      // Show modal after form is created
      this.visibleModal = true;
    },
    getSpecificFor(item) {
      // First check if target includes parents
      if (!item.target?.includes("parents")) {
        return "all";
      }

      // Then check which specific type is set
      if (
        item.classrooms &&
        Array.isArray(item.classrooms) &&
        item.classrooms.length > 0
      ) {
        return "classrooms";
      }
      if (item.levels && Array.isArray(item.levels) && item.levels.length > 0) {
        return "levels";
      }
      if (
        item.students &&
        Array.isArray(item.students) &&
        item.students.length > 0
      ) {
        return "students";
      }
      if (
        item.activities &&
        Array.isArray(item.activities) &&
        item.activities.length > 0
      ) {
        return "activities";
      }

      return "all";
    },
    handleCancel() {
      this.form.resetFields();
      this.visibleModal = false;
      this.photos = [];
      this.videos = [];
      this.description = "";
      this.enableComments = true;
      this.progress = { value: 0 };
      this.loading = false;
      this.isEdit = false;
      this.currentItem = null;
      this.selectedStudents = [];
      this.selectedTargetStudents = [];
      this.selectedTeachers = [];
    },
    moment,
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            if (this.isEdit) {
              await this.editActuality(values);
            } else {
              await this.addActuality(values);
            }
          } catch (error) {
            this.$message.error(
              this.isEdit
                ? this.$t("error.impoPubModif")
                : this.$t("error.impoPubAjout")
            );
          } finally {
            this.loading = false;
            this.handleCancel();
          }
        }
      });
    },
    async addActuality(values) {
      const actuality = {
        title: values.title,
        plannifDate: values.plannifDate,
        category: this.isAlbum ? "album" : this.getCategoryFromValues(values),
        desc: this.description,
        target: values.target,
        students: null,
        levels: null,
        classrooms: null,
        activities: null,
        teachers: null,
        levelsTeachers: null,
        classroomsTeachers: null,
        targetStudents: null,
        levelsStudents: null,
        classroomsStudents: null,
        photos: [],
        enableComments: this.enableNewsComments ? this.enableComments : false,
      };

      // Handle specific targets for parents
      if (values.target.includes("parents")) {
        if (values.specificFor === "students") {
          actuality.students = this.selectedStudents.map(
            (student) => student._id
          );
        } else if (values.specificFor === "levels") {
          actuality.levels = values.levels;
        } else if (values.specificFor === "classrooms") {
          actuality.classrooms = values.classrooms;
        } else if (values.specificFor === "activities") {
          actuality.activities = values.activities;
        }
      }

      // Handle specific targets for students
      if (values.target.includes("students")) {
        if (values.specificForStudents === "students") {
          actuality.targetStudents = this.selectedTargetStudents.map(
            (s) => s._id
          );
        } else if (values.specificForStudents === "levels") {
          actuality.levelsStudents = values.levelsStudents || null;
        } else if (values.specificForStudents === "classrooms") {
          actuality.classroomsStudents = values.classroomsStudents || null;
        } else if (values.specificForStudents === "activities") {
          actuality.activities = values.activitiesStudents || null;
        }
      }

      // Handle teacher-specific targets
      if (values.target.includes("teacher")) {
        if (values.specificForTeachers === "teachers") {
          actuality.teachers = this.selectedTeachers.map(
            (teacher) => teacher._id
          );
        } else if (values.specificForTeachers === "levels") {
          actuality.levelsTeachers = values.levelsTeachers || null;
        } else if (values.specificForTeachers === "classrooms") {
          actuality.classroomsTeachers = values.classroomsTeachers || null;
        }
      }

      // Upload photos if any
      if (this.photos.length > 0) {
        const photosToUpload = this.isAlbum
          ? this.photos.map((photo) => photo.originFileObj)
          : this.photos;
        actuality.photos = await uploadFilesToS3(
          photosToUpload,
          "manager/actuality",
          this.progress
        );
      }

      // Upload videos if any
      if (this.videos.length > 0) {
        const videosToUpload = this.videos.filter((v) => !v.isExisting);
        if (videosToUpload.length > 0) {
          const uploadedVideoKeys = await uploadFilesToS3(
            videosToUpload,
            "manager/actuality/videos",
            this.progress
          );

          // Initialize videos array with originalKey only
          // Backend will set status, createdAt, updatedAt, and renditions defaults
          actuality.videos = uploadedVideoKeys.map((videoKey) => ({
            originalKey: videoKey,
          }));

          // Add existing videos if editing
          const existingVideos = this.videos
            .filter((v) => v.isExisting)
            .map((v) => v.response);
          if (existingVideos.length > 0) {
            actuality.videos = [...existingVideos, ...actuality.videos];
          }
        } else {
          // Only existing videos, keep them as-is
          actuality.videos = this.videos
            .filter((v) => v.isExisting)
            .map((v) => v.response);
        }
      }

      // Create actuality
      const response = await apiClient.put("/actuality", actuality);
      this.$message.success(this.$t("success.pubAjout"));
      this.$emit("newsUpdated");
    },

    async editActuality(values) {
      let data = {};

      // Only add changed fields
      if (values.title !== this.currentItem.title) {
        data.title = values.title;
      }

      if (this.description !== this.currentItem.desc) {
        data.desc = this.description;
      }

      const category = this.isAlbum ? "album" : this.getCategoryFromValues(values);
      if (category !== this.currentItem.category) {
        data.category = category;
      }

      // if global switch is OFF, always false. If ON, use data property value
      const newEnableComments = this.enableNewsComments ? this.enableComments : false;
      if (newEnableComments !== (this.currentItem.enableComments !== false)) {
        data.enableComments = newEnableComments;
      }

      // Check if target has changed
      if (
        JSON.stringify(values.target) !==
        JSON.stringify(this.currentItem.target)
      ) {
        data.target = values.target;

        // If the current item had parents, students, or teachers but new target doesn't, or target changed in any way
        if (
          this.currentItem.target.includes("parents") ||
          this.currentItem.target.includes("students") ||
          this.currentItem.target.includes("teacher") ||
          (this.currentItem.students && this.currentItem.students.length > 0) ||
          (this.currentItem.levels && this.currentItem.levels.length > 0) ||
          (this.currentItem.classrooms &&
            this.currentItem.classrooms.length > 0) ||
          (this.currentItem.activities &&
            this.currentItem.activities.length > 0) ||
          (this.currentItem.teachers && this.currentItem.teachers.length > 0) ||
          (this.currentItem.levelsTeachers &&
            this.currentItem.levelsTeachers.length > 0) ||
          (this.currentItem.classroomsTeachers &&
            this.currentItem.classroomsTeachers.length > 0) ||
          (this.currentItem.targetStudents &&
            this.currentItem.targetStudents.length > 0) ||
          (this.currentItem.levelsStudents &&
            this.currentItem.levelsStudents.length > 0) ||
          (this.currentItem.classroomsStudents &&
            this.currentItem.classroomsStudents.length > 0)
        ) {
          // Always clear specific targeting when target changes
          data.students = null;
          data.levels = null;
          data.classrooms = null;
          data.activities = null;
          data.teachers = null;
          data.levelsTeachers = null;
          data.classroomsTeachers = null;
          data.targetStudents = null;
          data.levelsStudents = null;
          data.classroomsStudents = null;
        }

        // Only set new specific targeting if parents are included in the new target
        if (values.target.includes("parents")) {
          if (values.specificFor === "students") {
            const newStudentIds = this.selectedStudents.map((s) => s._id);
            data.students = newStudentIds;
          } else if (values.specificFor === "levels") {
            data.levels = values.levels || null;
          } else if (values.specificFor === "classrooms") {
            data.classrooms = values.classrooms || null;
          } else if (values.specificFor === "activities") {
            data.activities = values.activities || null;
          }
        }

        // Only set new specific targeting if students are included in the new target
        if (values.target.includes("students")) {
          if (values.specificForStudents === "students") {
            data.targetStudents = this.selectedTargetStudents.map((s) => s._id);
            data.levelsStudents = null;
            data.classroomsStudents = null;
            data.activities = null;
          } else if (values.specificForStudents === "levels") {
            data.levelsStudents = values.levelsStudents || null;
            data.targetStudents = null;
            data.classroomsStudents = null;
            data.activities = null;
          } else if (values.specificForStudents === "classrooms") {
            data.classroomsStudents = values.classroomsStudents || null;
            data.targetStudents = null;
            data.levelsStudents = null;
            data.activities = null;
          } else if (values.specificForStudents === "activities") {
            data.activities = values.activitiesStudents || null;
            data.targetStudents = null;
            data.levelsStudents = null;
            data.classroomsStudents = null;
          } else {
            data.targetStudents = null;
            data.levelsStudents = null;
            data.classroomsStudents = null;
            data.activities = null;
          }
        }

        if (values.target.includes("teacher")) {
          if (values.specificForTeachers === "teachers") {
            data.teachers = this.selectedTeachers.map((t) => t._id);
            data.levelsTeachers = null;
            data.classroomsTeachers = null;
          } else if (values.specificForTeachers === "levels") {
            data.levelsTeachers = values.levelsTeachers || null;
            data.teachers = null;
            data.classroomsTeachers = null;
          } else if (values.specificForTeachers === "classrooms") {
            data.classroomsTeachers = values.classroomsTeachers || null;
            data.teachers = null;
            data.levelsTeachers = null;
          } else {
            data.teachers = null;
            data.levelsTeachers = null;
            data.classroomsTeachers = null;
          }
        }
      } else if (
        this.currentItem.target.includes("parents") ||
        this.currentItem.target.includes("students") ||
        this.currentItem.target.includes("teacher")
      ) {
        // Handle parents targeting
        if (this.currentItem.target.includes("parents")) {
          // Only handle specificFor fields if target hasn't changed and includes parents
          if (values.specificFor === "students") {
            const newStudentIds = this.selectedStudents.map((s) => s._id);
            // Only add if different from current
            if (
              JSON.stringify(newStudentIds) !==
              JSON.stringify(this.currentItem.students || [])
            ) {
              data.students = newStudentIds;
              data.levels = null;
              data.classrooms = null;
              data.activities = null;
            }
          } else if (values.specificFor === "levels") {
            // Only add if different from current
            if (
              JSON.stringify(values.levels || []) !==
              JSON.stringify(this.currentItem.levels || [])
            ) {
              data.levels = values.levels || null;
              data.students = null;
              data.classrooms = null;
              data.activities = null;
            }
          } else if (values.specificFor === "classrooms") {
            // Only add if different from current
            if (
              JSON.stringify(values.classrooms || []) !==
              JSON.stringify(this.currentItem.classrooms || [])
            ) {
              data.classrooms = values.classrooms || null;
              data.students = null;
              data.levels = null;
              data.activities = null;
            }
          } else if (values.specificFor === "activities") {
            // Only add if different from current
            if (
              JSON.stringify(values.activities || []) !==
              JSON.stringify(this.currentItem.activities || [])
            ) {
              data.activities = values.activities || null;
              data.students = null;
              data.levels = null;
              data.classrooms = null;
            }
          } else if (values.specificFor === "all") {
            // If switching to "all" and we had specific targeting before
            if (
              this.currentItem.students?.length > 0 ||
              this.currentItem.levels?.length > 0 ||
              this.currentItem.classrooms?.length > 0 ||
              this.currentItem.activities?.length > 0
            ) {
              data.students = null;
              data.levels = null;
              data.classrooms = null;
              data.activities = null;
            }
          }
        }

        // Handle students targeting
        if (this.currentItem.target.includes("students")) {
          if (values.specificForStudents === "students") {
            const newTargetStudentIds = this.selectedTargetStudents.map(
              (s) => s._id
            );
            if (
              JSON.stringify(newTargetStudentIds) !==
              JSON.stringify(this.currentItem.targetStudents || [])
            ) {
              data.targetStudents = newTargetStudentIds;
              data.levelsStudents = null;
              data.classroomsStudents = null;
              data.activities = null;
            }
          } else if (values.specificForStudents === "levels") {
            if (
              JSON.stringify(values.levelsStudents || []) !==
              JSON.stringify(this.currentItem.levelsStudents || [])
            ) {
              data.levelsStudents = values.levelsStudents || null;
              data.targetStudents = null;
              data.classroomsStudents = null;
              data.activities = null;
            }
          } else if (values.specificForStudents === "classrooms") {
            if (
              JSON.stringify(values.classroomsStudents || []) !==
              JSON.stringify(this.currentItem.classroomsStudents || [])
            ) {
              data.classroomsStudents = values.classroomsStudents || null;
              data.targetStudents = null;
              data.levelsStudents = null;
              data.activities = null;
            }
          } else if (values.specificForStudents === "activities") {
            if (
              JSON.stringify(values.activitiesStudents || []) !==
              JSON.stringify(this.currentItem.activities || [])
            ) {
              data.activities = values.activitiesStudents || null;
              data.targetStudents = null;
              data.levelsStudents = null;
              data.classroomsStudents = null;
            }
          } else if (values.specificForStudents === "all") {
            if (
              this.currentItem.targetStudents?.length > 0 ||
              this.currentItem.levelsStudents?.length > 0 ||
              this.currentItem.classroomsStudents?.length > 0 ||
              this.currentItem.activities?.length > 0
            ) {
              data.targetStudents = null;
              data.levelsStudents = null;
              data.classroomsStudents = null;
              data.activities = null;
            }
          }
        }

        // Handle teacher-specific targeting
        if (this.currentItem.target.includes("teacher")) {
          if (values.specificForTeachers === "teachers") {
            const newTeacherIds = this.selectedTeachers.map((t) => t._id);
            if (
              JSON.stringify(newTeacherIds) !==
              JSON.stringify(this.currentItem.teachers || [])
            ) {
              data.teachers = newTeacherIds;
              data.levelsTeachers = null;
              data.classroomsTeachers = null;
            }
          } else if (values.specificForTeachers === "levels") {
            if (
              JSON.stringify(values.levelsTeachers || []) !==
              JSON.stringify(this.currentItem.levelsTeachers || [])
            ) {
              data.levelsTeachers = values.levelsTeachers || null;
              data.teachers = null;
              data.classroomsTeachers = null;
            }
          } else if (values.specificForTeachers === "classrooms") {
            if (
              JSON.stringify(values.classroomsTeachers || []) !==
              JSON.stringify(this.currentItem.classroomsTeachers || [])
            ) {
              data.classroomsTeachers = values.classroomsTeachers || null;
              data.teachers = null;
              data.levelsTeachers = null;
            }
          } else if (values.specificForTeachers === "all") {
            if (
              this.currentItem.teachers?.length > 0 ||
              this.currentItem.levelsTeachers?.length > 0 ||
              this.currentItem.classroomsTeachers?.length > 0
            ) {
              data.teachers = null;
              data.levelsTeachers = null;
              data.classroomsTeachers = null;
            }
          }
        }
      }

      // Handle photos - get existing photos that weren't deleted
      const currentPhotos = this.currentItem.photos || [];
      const remainingPhotos = this.photos
        .filter((p) => p.isExisting)
        .map((p) => p.response);

      // Track deleted photos to remove from S3
      const deletedPhotos = currentPhotos.filter(
        (photo) => !remainingPhotos.includes(photo)
      );

      // Get new photos that need to be uploaded
      const newPhotos = this.photos.filter((p) => !p.isExisting);

      // Upload new photos to S3 if any
      if (newPhotos.length > 0) {
        const photosToUpload = this.isAlbum
          ? newPhotos.map((photo) => photo.originFileObj)
          : newPhotos;

        const uploadedPhotos = await uploadFilesToS3(
          photosToUpload,
          "manager/actuality",
          this.progress
        );

        // Combine existing photos with newly uploaded ones
        data.photos = [...remainingPhotos, ...uploadedPhotos];
      } else if (
        JSON.stringify(currentPhotos) !== JSON.stringify(remainingPhotos)
      ) {
        // If we only have deletions but no new uploads
        data.photos = remainingPhotos;
      }

      // Add deleted photos to data for backend processing
      if (deletedPhotos.length > 0) {
        data.deletedPhotos = deletedPhotos;
      }

      // Handle videos - get existing videos that weren't deleted
      const currentVideos = this.currentItem.videos || [];
      const remainingVideos = this.videos
        .filter((v) => v.isExisting)
        .map((v) => v.response);

      // Track deleted videos to remove from S3
      const deletedVideos = currentVideos.filter(
        (video) => !remainingVideos.find((rv) =>
          (rv._id && video._id && rv._id.toString() === video._id.toString()) ||
          (rv.originalKey && video.originalKey && rv.originalKey === video.originalKey)
        )
      );

      // Get new videos that need to be uploaded
      const newVideos = this.videos.filter((v) => !v.isExisting);

      // Upload new videos to S3 if any
      if (newVideos.length > 0) {
        const uploadedVideoKeys = await uploadFilesToS3(
          newVideos,
          "manager/actuality/videos",
          this.progress
        );

        // Initialize new videos with originalKey only
        // Backend will set status, createdAt, updatedAt, and renditions defaults
        const newVideoObjects = uploadedVideoKeys.map((videoKey) => ({
          originalKey: videoKey,
        }));

        // Combine existing videos with newly uploaded ones
        data.videos = [...remainingVideos, ...newVideoObjects];
      } else if (
        JSON.stringify(currentVideos) !== JSON.stringify(remainingVideos)
      ) {
        // If we only have deletions but no new uploads
        data.videos = remainingVideos;
      }

      // Add deleted videos to data for backend processing
      if (deletedVideos.length > 0) {
        data.deletedVideos = deletedVideos;
      }

      // Only make the API call if there are changes
      if (Object.keys(data).length > 0) {
        const response = await apiClient.put(
          "/actuality/" + this.currentItem._id + "/update",
          data
        );
        this.$message.success(this.$t("success.pubModif"));
        this.$emit("newsUpdated");
      }
    },
    getFileExtension(filename) {
      const parts = (filename || "").toLowerCase().split(".");
      return parts.length > 1 ? parts.pop() || "" : "";
    },
    isAllowedNewsImage(file) {
      const ext = this.getFileExtension(file.name);
      const mime = (file.type || "").toLowerCase();
      const allowedImageExts = ["jpg", "jpeg", "png"];
      const allowedImageMimes = ["image/jpeg", "image/png"];
      // Reject .jfif even when browsers report MIME as image/jpeg
      return (
        allowedImageExts.includes(ext) &&
        (!mime || allowedImageMimes.includes(mime))
      );
    },
    isAllowedNewsAttachment(file) {
      const ext = this.getFileExtension(file.name);
      const mime = (file.type || "").toLowerCase();
      const allowedExts = ["jpg", "jpeg", "png", "pdf", "doc", "docx"];
      const allowedMimes = [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedExts.includes(ext)) return false;
      if (mime && !allowedMimes.includes(mime)) return false;
      if (["jpg", "jpeg", "png"].includes(ext)) {
        return this.isAllowedNewsImage(file);
      }
      return true;
    },
    beforeUploadFiles(file, _) {
      const isValidType = this.isAllowedNewsAttachment(file);
      if (!isValidType) {
        this.$message.error(this.$t("error.fichiersPDFWord"));
      }

      const islt15 = this.photos.length < 15;
      if (!islt15) {
        this.$message.error(
          this.isAlbum ? this.$t("error.maxImage") : this.$t("error.maxFiles")
        );
      }

      let maxSize = 0;
      this.photos.forEach((f) => {
        maxSize += f.size;
      });
      maxSize += file.size;
      maxSize = maxSize / 1024 / 1024;
      if (maxSize > 50) {
        this.$message.error(this.$t("error.image50"));
      }

      if (isValidType && islt15 && maxSize <= 50) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.photos.push(file);
      }
      return isValidType && islt15 && maxSize <= 50;
    },
    beforeUploadFilesAlbum(file, _) {
      const isJpgOrPng = this.isAllowedNewsImage(file);
      if (!isJpgOrPng) {
        this.$message.error(this.$t("error.fichiers"));
      }
      const islt15 = this.photos.length < 15;
      if (!islt15) {
        this.$message.error(
          this.isAlbum ? this.$t("error.maxImage") : this.$t("error.maxFiles")
        );
      }

      let maxSize = 0;
      this.photos.forEach((f) => {
        maxSize += f.size;
      });
      maxSize += file.size;
      maxSize = maxSize / 1024 / 1024;
      if (maxSize > 50) {
        this.$message.error(this.$t("error.image50"));
      }

      if (isJpgOrPng && islt15 && maxSize <= 50) {
        this.$message.success(
          this.$t("success.imageTelecharge", { name: file.name })
        );
        this.photos.push(file);
      }
      return isJpgOrPng && islt15 && maxSize <= 50;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange(e) {
      if (e.file) {
        if (e.file.status === "removed") {
          const index = this.photos.indexOf(e.file);
          if (index !== -1) {
            this.photos.splice(index, 1);
          }
          return;
        }
        const isJpgOrPng = this.isAllowedNewsImage(e.file);

        const islt15 = this.photos.length < 15;

        let maxSize = 0;
        this.photos.forEach((f) => {
          maxSize += f.size;
        });
        maxSize += e.file.size;
        maxSize = maxSize / 1024 / 1024;
        if (isJpgOrPng && islt15 && maxSize <= 50) {
          this.photos = e.fileList;
          e.file.status = "done";
        }
      }
    },
    handleChangeUpload(info) {
      const { status } = info.file;
      if (status === "removed") {
        const index = this.photos.indexOf(info.file);
        if (index !== -1) {
          this.photos.splice(index, 1);
        }
      }
    },
    beforeUploadVideos(file, _) {
      const allowedTypes = [
        "video/mp4",
        "video/mpeg",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-matroska",
        "video/webm",
      ];
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error(this.$t("error.videoFormat"));
      }

      const islt5 = this.videos.length < 5;
      if (!islt5) {
        this.$message.error(this.$t("error.maxVideos"));
      }

      // Check file size (e.g., max 500MB per video)
      const maxSizeMB = 500;
      const fileSizeMB = file.size / 1024 / 1024;
      if (fileSizeMB > maxSizeMB) {
        this.$message.error(this.$t("error.videoSize"));
      }

      if (isValidType && islt5 && fileSizeMB <= maxSizeMB) {
        this.$message.success(
          this.$t("success.videoAdded", { name: file.name })
        );
        this.videos.push(file);
      }
      return isValidType && islt5 && fileSizeMB <= maxSizeMB;
    },
    handleChangeVideoUpload(info) {
      const { status } = info.file;
      if (status === "removed") {
        const index = this.videos.indexOf(info.file);
        if (index !== -1) {
          this.videos.splice(index, 1);
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "./form-shared.scss";
</style>
